import { render, staticRenderFns } from "./customerMessageSettings.vue?vue&type=template&id=d8ca6d0a&scoped=true&"
import script from "./customerMessageSettings.vue?vue&type=script&lang=js&"
export * from "./customerMessageSettings.vue?vue&type=script&lang=js&"
import style0 from "./customerMessageSettings.vue?vue&type=style&index=0&id=d8ca6d0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ca6d0a",
  null
  
)

export default component.exports